import React from "react";
import PageBanner from "../../../components/sections/front/Common/PageBanner";
import BannerImage from "../../../assets/image/image-page-banner.webp";
import OurPartners from "../../../components/sections/front/Common/OurPartners";
import { useBanner } from "../../../providers/BannerProviders";
import { useLocation } from "react-router-dom";
import SectionAllProjects from "../../../components/sections/front/Projects/SectionAllProject";

const AllProjects = () => {
  const { data } = useBanner();
  const projectBanner = data?.data?.find(
    (item) => item?.bannerType === "projects"
  );
  const location = useLocation();
  const projectData = location.state?.projectData;

  return (
    <>
      <PageBanner
        title={"All " + projectBanner?.title}
        image={projectBanner?.image?.url}
      />
      <SectionAllProjects projectData={projectData} />
      <OurPartners />
    </>
  );
};

export default AllProjects;
